import {
  REFERRAL_SOURCES,
  REFERRAL_SOURCES_FOR_META
} from 'bento-ordering/base/constants/referralSources';

export const validateReferralSource = referralSource =>
  REFERRAL_SOURCES.includes(referralSource) ? referralSource : null;

export const validateReferralSourceForMeta = referralSource =>
  REFERRAL_SOURCES_FOR_META.includes(referralSource) ? referralSource : null;
